/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Speed_Title5Inputs */

const en_svc_full_stack_web_apps_speed_title5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Speed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance budget`)
};

const ar_svc_full_stack_web_apps_speed_title5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Speed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ميزانية الأداء`)
};

const bn_svc_full_stack_web_apps_speed_title5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Speed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পারফরম্যান্স বাজেট`)
};

const de_svc_full_stack_web_apps_speed_title5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Speed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistungsbudget`)
};

const es_svc_full_stack_web_apps_speed_title5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Speed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presupuesto de desempeño`)
};

const fr_svc_full_stack_web_apps_speed_title5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Speed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget de performance`)
};

const pt_svc_full_stack_web_apps_speed_title5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Speed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orçamento de desempenho`)
};

const zh_svc_full_stack_web_apps_speed_title5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Speed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绩效预算`)
};

const tr_svc_full_stack_web_apps_speed_title5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Speed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performans bütçesi`)
};

const ru_svc_full_stack_web_apps_speed_title5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Speed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бюджет производительности`)
};

const pl_svc_full_stack_web_apps_speed_title5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Speed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budżet wydajności`)
};

/**
* | output |
* | --- |
* | "Performance budget" |
*
* @param {Svc_Full_Stack_Web_Apps_Speed_Title5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_speed_title5 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Speed_Title5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Speed_Title5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_speed_title5(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_speed_title5(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_speed_title5(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_speed_title5(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_speed_title5(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_speed_title5(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_speed_title5(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_speed_title5(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_speed_title5(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_speed_title5(inputs)
	return en_svc_full_stack_web_apps_speed_title5(inputs)
});
export { svc_full_stack_web_apps_speed_title5 as "svc_full-stack-web-apps_SPEED_title" }